"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BandwidthLevel = void 0;
// this is in a separate module from low_bandwidth_metrics_observer.ts to work around
//     https://github.com/kulshekhar/ts-jest/issues/281
var BandwidthLevel;
(function (BandwidthLevel) {
    BandwidthLevel["LOW"] = "Low";
    BandwidthLevel["NORMAL"] = "Normal";
    BandwidthLevel["NONE"] = "None";
})(BandwidthLevel = exports.BandwidthLevel || (exports.BandwidthLevel = {}));
//# sourceMappingURL=bandwidth_level.js.map